import * as z from "zod";

/** Captures the storefront's live signup popup at its phone step. */
export const generateRcsOptInScreenshot = {
  name: "generateRcsOptInScreenshot" as const,
  input: z.object({}),
  output: z.object({
    status: z.enum(["started", "blocked"]),
    /** Poll `getRcsOptInScreenshot` with this. */
    workflowId: z.string().optional(),
    reason: z.string().optional(),
    detail: z.string().optional(),
    missingFields: z.array(z.string()).optional(),
  }),
};

export const getRcsOptInScreenshot = {
  name: "getRcsOptInScreenshot" as const,
  input: z.object({ workflowId: z.string() }),
  output: z.object({
    status: z.enum(["running", "completed", "failed"]),
    detail: z.string().optional(),
    screenshotUrl: z.string().optional(),
    /** The consent text read off the captured form. */
    disclosure: z.string().optional(),
  }),
};
